import React from "react";
import { twMerge } from "tailwind-merge";

function Container({className, children}) {
	return (
		<div className="flex flex-1 justify-center items-start">
			<div
				className={twMerge(
					`grid grid-cols-12 md:w-auto w-full my-5 gap-1 p-4 !shadow-subMain/25 shadow-[0_3px_20px_2px_rgb(255,255,255)]`,
					className
				)}>
				{children}
			</div>
		</div>
	);
}

export default Container;
